import type { FC } from "react";
import { Box } from "../../shared/components/Box/Box";
import { IconNames } from "../../shared/components/Icon/svg";
import classes from "./Referral.module.scss";
import { v4 as uuidv4 } from "uuid";

export interface BoxInterface {
	image: string;
	title: string;
	text: string;
	links?: IconNames[];
}

export const Referral: FC = () => {
	const box: BoxInterface[] = [
		{
			image: "images/rocket.png",
			title: "Join the Program",
			text: "To start, sign up for our referral program. Once you've registered, you'll receive a unique referral link that you can share with your friends, family, and social network.",
		},

		{
			image: "images/message.png",
			title: "Share Your Link",
			text: "Promote our token with your referral link. Share it through email, social media, blogs, etc. Those clicking your link and making a purchase count as your referrals.",
		},

		{
			image: "images/money.png",
			title: "Earn Tokens",
			text: "For each referral, earn reward tokens. More referrals mean more tokens. Use, trade, or sell tokens within our platform, depending on their functionality. Your earn power is in your hands.",
		},

		{
			image: "images/finger.png",
			title: "Follow Us",
			text: "Become a part of our digital family by following us on social media platforms. Stay tuned to our latest updates, events, and special promotions.",
			links: ["discord", "telegram", "twitter", "youtube"],
		},
	];

	return (
		<div className={classes.wrapper}>
			<h2 className={classes.title}>Referral program</h2>
			<div className={classes.boxes}>
				{box.map(({ image, title, text, links }) => (
					<Box
						className={classes.box}
						key={uuidv4()}
						image={image}
						title={title}
						links={links}
					>
						{text}
					</Box>
				))}
			</div>
		</div>
	);
};
